import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Printer, X } from 'lucide-react';
import { CenterMorphModal, CenterMorphModalContent } from './beui/CenterMorphModal';
import { Button } from './ui/button';
import ResitView, { RESIT_CSS } from './ResitView';

export default function ResitDialog({ open, onOpenChange, resit, school }) {
  const { t } = useTranslation();
  const [mode, setMode] = useState('thermal');
  if (!resit) return null;

  const doPrint = (m) => {
    setMode(m);
    let el = document.getElementById('resit-page-style');
    if (!el) { el = document.createElement('style'); el.id = 'resit-page-style'; document.head.appendChild(el); }
    el.innerHTML = m === 'thermal'
      ? '@page{size:80mm auto;margin:3mm}'
      : '@page{size:A4;margin:14mm}';
    setTimeout(() => window.print(), 80);
  };

  return (
    <CenterMorphModal open={open} onOpenChange={onOpenChange}>
      <CenterMorphModalContent ariaLabel={`${t('resit')} #${resit.no_resit}`} className="max-w-md bg-card" data-testid="resit-dialog">
        <style>{RESIT_CSS}</style>
        <div className="p-6">
          <div className="mb-4 pr-8">
            <h2 className="text-lg font-extrabold text-foreground">{t('resit')} #{resit.no_resit}</h2>
          </div>

          <ResitView resit={resit} school={school} mode={mode} />

          <div className="flex gap-2 no-print mt-4">
            <Button onClick={() => doPrint('thermal')} className="flex-1 h-11 bg-brand text-white hover:bg-brand-royal" data-testid="print-thermal">
              <Printer className="h-4 w-4 mr-1.5" />{t('cetak80')}
            </Button>
            <Button onClick={() => doPrint('a4')} variant="outline" className="flex-1 h-11" data-testid="print-a4">
              <Printer className="h-4 w-4 mr-1.5" />{t('cetakA4')}
            </Button>
            <Button onClick={() => onOpenChange(false)} variant="ghost" className="h-11" data-testid="resit-close">
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </CenterMorphModalContent>
    </CenterMorphModal>
  );
}
